import { Component } from '@angular/core';
import { OccupationService } from '../occupation.service';
import { Occupation } from '../occupation';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-occupation-edit',
  templateUrl: 'edit.component.html',
})
export class OccupationEditComponent {
  /**
   * Details of the occupation being edited.
   */
  public occupation: Occupation;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {OccupationService} occupationService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private occupationService: OccupationService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.occupationService.loading.subscribe(
      result => (this.isLoading = result),
    );
    this.route.params.subscribe(params => this.loadOccupation(params.id));
  }

  /**
   * Perform the edit action which send the edited occupation to the backend.
   */
  public edit() {
    const editOccupation = this.occupationService
      .updateOccupation(this.occupation.id, this.occupation)
      .subscribe(
        (result: Occupation) => {
          this.notificationService.success(
            `Occupation Updated`,
            `The occupation ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.occupation = new Occupation();
          editOccupation.unsubscribe();
          this.router.navigate(['/occupations']);
        },
        err => {
          this.notificationService.error(
            `Occupation Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/occupations']);
        },
      );
  }

  /**
   * Loads the requested occupation so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadOccupation(id: string) {
    this.occupationService.findOccupation(id).subscribe(
      result => {
        this.occupation = result;
      },
      err => {
        this.notificationService.error(
          `Occupation Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/occupations']);
      },
    );
  }
}
